function getForm(config) {
	return document.getElementById(`gform_${config.formId}`);
}

function getHelperText(helperTextMap, fieldId) {
	if (!fieldId) {
		return '';
	}

	const rawValue = helperTextMap?.[fieldId];
	if (typeof rawValue !== 'string') {
		return '';
	}

	return rawValue.trim();
}

function openSideMenu(sideMenu, sideMenuContent, helperText, fallbackText) {
	const nextText = helperText !== '' ? helperText : fallbackText;
	sideMenuContent.textContent = nextText;
	sideMenu.classList.add('open');
}

function closeSideMenu(sideMenu) {
	sideMenu.classList.remove('open');
}

export function bindHelperSideMenu(app) {
	const form = getForm(app.config);
	if (!form) {
		return;
	}

	const sideMenu = document.querySelector('.sd-side-menu');
	const sideMenuContent = sideMenu?.querySelector('.sd-side-menu__content-text');
	if (!(sideMenu instanceof HTMLElement) || !(sideMenuContent instanceof HTMLElement)) {
		app.logger.debug('Helper side menu bindings skipped: side menu container/content is missing.', {
			formId: app.config.formId,
		});
		return;
	}

	const helperTextMap = app.config.helperTextMap && typeof app.config.helperTextMap === 'object'
		? app.config.helperTextMap
		: {};
	const fallbackText = String(sideMenuContent.textContent || '').trim();
	const bindMarker = `sdConfigHelperSideMenuBound_${String(app.config.formId)}`;
	if (document.documentElement.dataset[bindMarker] === '1') {
		return;
	}

	document.addEventListener('click', (event) => {
		const target = event.target;
		if (!(target instanceof Element)) {
			return;
		}

		const closeButton = target.closest('.sd-side-menu__close');
		if (closeButton) {
			event.preventDefault();
			closeSideMenu(sideMenu);
			return;
		}

		const helperButton = target.closest('.sd-gf-helper-trigger');
		if (!(helperButton instanceof HTMLButtonElement) || !form.contains(helperButton)) {
			return;
		}

		event.preventDefault();

		const fieldId = String(helperButton.value || '').trim();
		const helperText = getHelperText(helperTextMap, fieldId);
		openSideMenu(sideMenu, sideMenuContent, helperText, fallbackText);
	});

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Escape') {
			return;
		}

		if (!sideMenu.classList.contains('open')) {
			return;
		}

		closeSideMenu(sideMenu);
	});

	document.documentElement.dataset[bindMarker] = '1';

	app.logger.debug('Helper side menu handlers attached.', {
		formId: app.config.formId,
		helperFieldCount: Object.keys(helperTextMap).length,
	});
}
